import { classNamesSetClass } from './utils'

export function classNamesSetLayoutWidth(classNames, layoutWidth) {
  return classNamesSetClass(classNames, 'lw-', layoutWidth)
}

export function setLayoutWidthBodyClass(layoutWidth) {
  window.document.body.className = classNamesSetLayoutWidth(window.document.body.className, layoutWidth)
}
